import _ from "lodash";

const validateGreyhoundProfile = (allowedProfiles, profile) =>
  !!_.find(allowedProfiles, (value) => value === profile);

export default validateGreyhoundProfile;
